import { Component, inject } from '@angular/core';
import { ImagesService } from '../../services/general/images.service';
import { NavigationEnd, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PermissionService } from '../../services/permission/permission.service';

@Component({
  selector: 'app-side-navbar',
  imports: [CommonModule],
  templateUrl: './side-navbar.component.html',
  styleUrl: './side-navbar.component.scss'
})
export class SideNavbarComponent {

  activeMenuItem: string = ''
  _images = inject(ImagesService)
  _router = inject(Router)
  permissionService = inject(PermissionService)

  ngOnInit() {
    // Call updateActiveMenuItem with the current URL on initial load
    this.updateActiveMenuItem(this._router.url);
    this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateActiveMenuItem(event.url);
      }
    });
  }

  updateActiveMenuItem(url: string) {
    const normalizedUrl = url.split('?')[0].replace(/\/$/, '');

    if (normalizedUrl.startsWith('/products') || normalizedUrl.startsWith('/product-details')) {
      this.activeMenuItem = 'products';
    } else if (normalizedUrl.startsWith('/dashboard')) {
      this.activeMenuItem = 'dashboard';
    } else if (normalizedUrl.startsWith('/institutions') || normalizedUrl.startsWith('/institution-detail')) {
      this.activeMenuItem = 'institutions';
    } else if (normalizedUrl.startsWith('/manage-users')) {
      this.activeMenuItem = 'users';
    } else if (normalizedUrl.startsWith('/api-keys')) {
      this.activeMenuItem = 'api-keys';
    } else if (normalizedUrl.startsWith('/categories')) {
      this.activeMenuItem = 'categories';
    } else if (normalizedUrl.startsWith('/loan-applications')) {
      this.activeMenuItem = 'loan-applications';
    } else if (normalizedUrl.startsWith('/webhook-trigger')) {
      this.activeMenuItem = 'webhook-trigger';
    } else if (normalizedUrl.startsWith('/application-forms')) {
      this.activeMenuItem = 'application-forms';
    } else {
      this.activeMenuItem = 'dashboard';
    }
  }

  options = [
    "All Products",
    "Loans",
  ]

  navigateTo(link: string) {
    this._router.navigate([link]);
  }

  getCurrentYear(): number {
    return new Date().getFullYear();
  }
}
